export const GET_ACCOUNTS_PENDING = "GET_ACCOUNTS_PENDING"
export const GET_ACCOUNTS_SUCCESS = "GET_ACCOUNTS_SUCCESS"
export const GET_ACCOUNTS_FAILURE = "GET_ACCOUNTS_FAILURE"

export const ADD_ACCOUNTS_PENDING = "ADD_ACCOUNTS_PENDING"
export const ADD_ACCOUNTS_SUCCESS = "ADD_ACCOUNTS_SUCCESS"
export const ADD_ACCOUNTS_FAILURE = "ADD_ACCOUNTS_FAILURE"

export const EDIT_ACCOUNTS_PENDING = "EDIT_ACCOUNTS_PENDING"
export const EDIT_ACCOUNTS_SUCCESS = "EDIT_ACCOUNTS_SUCCESS"
export const EDIT_ACCOUNTS_FAILURE = "EDIT_ACCOUNTS_FAILURE"

export const DELETE_ACCOUNTS_PENDING = "DELETE_ACCOUNTS_PENDING"
export const DELETE_ACCOUNTS_SUCCESS = "DELETE_ACCOUNTS_SUCCESS"
export const DELETE_ACCOUNTS_FAILURE = "DELETE_ACCOUNTS_FAILURE"
